import React, { createContext, useContext, useState } from "react";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import { sendData } from "../../../lib/dashboard/actions";

const DomesticMarketMonthlyStockSalesContext = createContext();

const DomesticMarketMonthlyStockSalesProvider = ({ children }) => {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isFavoritesModal, setIsFavoritesModal] = useState(false);
  const [chartData, setChartData] = useState({ data: [], isLoading: false });

  //GET COMPANIES LIST
  const companies = useSWR("/domestic/producer/company", fetchData, {
    revalidateOnFocus: false,
    dedupingInterval: 6000,
  });

  //FAVORITE LIST
  const { data: favorites, isValidating } = useSWR(
    "/favorite/domestic-production",
    fetchData,
    {
      revalidateOnFocus: false,
      dedupingInterval: 6000,
    }
  );

  //GET CHART DATA
  const handleShowChart = async (body) => {
    setChartData((prev) => ({ ...prev, isLoading: true }));
    const { status, data } = await sendData(body, "/domestic/producer-sell");
    if (status === 200) setChartData((prev) => ({ ...prev, data }));
    setChartData((prev) => ({ ...prev, isLoading: false }));
  };
  return (
    <DomesticMarketMonthlyStockSalesContext.Provider
      value={{
        companies,
        chartData: chartData.data,
        favorites,
        selectedCompany,
        setSelectedCompany,
        isFavoritesModal,
        setIsFavoritesModal,
        handleShowChart,
        isChartLoading: chartData.isLoading,
        isFavoritesValidation: isValidating,
      }}
    >
      {children}
    </DomesticMarketMonthlyStockSalesContext.Provider>
  );
};

export default DomesticMarketMonthlyStockSalesProvider;

export function useDomesticMarketMonthlyStockSalesContext() {
  return useContext(DomesticMarketMonthlyStockSalesContext);
}
